import { useState, useMemo } from "react";
import MusicActions from "./MusicActions";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { toast } from "react-toastify";
import DownloadPlaylistAction from "./DownloadPlaylistAction";
import Tooltip from "@mui/material/Tooltip";
function MusicTable({ data, event, onSongUpdate }: any) {

  const token = localStorage.getItem("token");
  
  const [sortConfig, setSortConfig] = useState(() => {
    const hasPerformanceType = event?.performance_type !== null && event?.performance_type !== undefined;
    return {
      key: hasPerformanceType ? 'entry_number' : 'song_id',
      direction: 'ascending'
    };
  });

  const sortedData = useMemo(() => {
    const sortableItems = [...data];
    
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (sortConfig.key === 'entry_number') {
  const aValue = parseInt(a.performance?.entry_number);
  const bValue = parseInt(b.performance?.entry_number);

      const aNum = isNaN(aValue) ? Infinity : aValue;
      const bNum = isNaN(bValue) ? Infinity : bValue;
            
        if (aNum < bNum) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (aNum > bNum) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      }
        
        if (sortConfig.key === 'song_id') {
          const aValue = parseInt(a.song_id);
          const bValue = parseInt(b.song_id);
          
          if (aValue < bValue) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (aValue > bValue) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        
        return 0;
      });
    }
    
    return sortableItems;
  }, [data, sortConfig]);

  const requestSort = (key: any) => {
    setSortConfig(prevConfig => {
      if (prevConfig.key === key) {
        return {
          key,
          direction: prevConfig.direction === 'ascending' ? 'descending' : 'ascending'
        };
      }
      return {
        key,
        direction: 'ascending'
      };
    });
  };

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadAll = async () => {
    setIsDownloading(true);
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/events/${event.id}/downloadallsongs-zip`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            event_id: event.id,
            event_location: event.location,
          }),
        }
      );

      const result = await response.json();
      console.log("Download All Response:", result);

      if (!response.ok) {
        toast.warn(result.message);  
        //alert(result.message || "Failed to start ZIP process");
        setIsDownloading(false);
        return;
      }

      toast.info(result.message);
    } catch (err) {
      console.error("Error downloading all:", err);
      alert("Something went wrong starting the ZIP process.");
      setIsDownloading(false);
    }
  };

  const hasSongsUploaded = data?.some(
    (item: any) => item?.s3_file_key != null && item?.s3_file_key !== ""
  );
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  //alert(hasSongsUploaded);
  const isDownloadDisabled = isLocalhost || event?.performance_type == null;

  const button_downloadAllSongs  = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "downloadallsongs")?.ModulesPermissions?.view;
  const button_downloadPlaylist = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "downloadplaylist")?.ModulesPermissions?.view;

  return (
    <div className="music-dashboard">
      <div className="table-container">
        <div className="table-wrapper">
          <table className="music-table">
            <thead>
              <tr className="table-header">
                <th 
                  className="song-id clickable"
                  onClick={() => requestSort('song_id')}
                  style={{ cursor: 'pointer' }}
                >
                  Song ID 
                  {sortConfig.key === 'song_id' ? (
                    sortConfig.direction === 'ascending' 
                    ? 
                    <KeyboardArrowUpOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle" }} /> : 
                    <KeyboardArrowDownOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle" }} />
                  ) : (
                    <KeyboardArrowUpOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle", opacity: 0.5 }} />
                  )}
                </th>

                <th 
                  className="entry-col clickable"
                  onClick={() => requestSort('entry_number')}
                  style={{ cursor: 'pointer' }}
                >
                  Entry
                  {sortConfig.key === 'entry_number' ? (
                    sortConfig.direction === 'ascending' 
                    ? 
                  <KeyboardArrowUpOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle" }} /> : 
                  <KeyboardArrowDownOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle" }} />
                  ) : (
                    <KeyboardArrowUpOutlinedIcon style={{ fontSize: "16px", verticalAlign: "middle", opacity: 0.5 }} />
                  )}
                </th>
                <th className="program-col">Program</th>
                <th className="style-col">Style</th>
                <th className="mk-col">MK#</th>
                <th className="class-col">Description</th>
                  <th className="actions-col">
                    <div className="header-buttons-equal">
                      {button_downloadPlaylist && (
                        <div className="button-half">
                        <DownloadPlaylistAction event={event} hasSongsUploaded={hasSongsUploaded}/>
                        </div>
                      )}

                      {button_downloadAllSongs && (
                    <div className="button-half">
                      <Tooltip
                        title={event?.performance_type == null ? "No entry numbers available yet" : ""}
                        enterDelay={0}
                        leaveDelay={0}
                      >
                      <span>
                      <button
                        className="download-all-btn"
                        onClick={(e) => {
                          if (isDownloadDisabled || isDownloading) {
                            e.preventDefault();
                            return;
                          }
                          handleDownloadAll();
                        }}
                        disabled={isDownloadDisabled || isDownloading}
                        style={{
                          cursor: (isDownloadDisabled || isDownloading) ? 'not-allowed' : 'pointer',
                          opacity: (isDownloadDisabled || isDownloading) ? 0.3 : 1
                        }}
                      >
                            <DownloadForOfflineIcon style={{ fontSize: "20px" }} />
                            <span>
                              {isLocalhost ? "localhost" : ""}
                              {isDownloading ? "Downloading..." : " Songs"}
                            </span>
                          </button>
                          </span>
                          </Tooltip>
                        </div>
                    )}
                  </div>
                  </th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((item: any, index: number) => (
                <tr
                  key={item.id || index}
                  className="table-row"
                >
                  <td className="song-data">{item.song_id}</td>
                  <td className="program-data">{item.performance?.entry_number || "-"}</td>
                  <td className="program-data">{item.program}</td>
                  <td className="style-data">{item.style}</td>
                  <td className="mk-data">{item.class || item.class}</td>
                  <td className="class-data">{item.description}</td>
                  <td className="actions-data">
                    <MusicActions item={item} event={event} onSongUpdate={onSongUpdate}/>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MusicTable;